export default "__VITE_ASSET__KGhvGiKF__"